import moment from 'moment';
import { call, fork, put, select, take } from 'redux-saga/effects';
import { getJSON } from '../util';


export function* fetch(date, user) {
    const url = '/api/of-the-day/hexagram';
    let response;

    try {
        response = yield call(getJSON, url,
            // date == Y-M-D format
            { date: date, birthdate: user.birth_date || undefined },
            { cache: false }
        );
    } catch (e) {
        return;
    }

    const payload = { [user.logged_in ? 'you' : 'everyone']: response.data };
    yield put({type: 'hexagram:update', payload});
}

export function* root() {
    const action = yield take('hexagram:required');
    const date = action.payload || moment().format('YYYY-MM-DD');
    const user = yield select(state => state.user);

    yield fork(fetch, date, user);

    if (user) {
        // also fetch the "for everyone" version, if we didn't just do that already
        yield fork(fetch, date, { logged_in: false });
    }

    while (true) {
        let action = yield take('user:logged-in');
        yield fork(fetch, date, action.payload);
    }
}



// WEBPACK FOOTER //
// ./app/sagas/hexagram.js